// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__MU0PQ","large":"styles_large___F63p"};